import { useEphattaQuery } from "../../.."
import { useAdvertBookingService } from "./useAdvertBookingService"

export const useAdvertBookingsByUser = (userId: string) => {
    const service = useAdvertBookingService()
    return useEphattaQuery(["Adverts.Booking.GetAll", userId], () => service.GetByUserId(userId))
} 